import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { PRODUK_SIAP, type Produk } from '../lib/data'

function Tautan({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link
      to={to}
      className="rounded-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
    >
      {children}
    </Link>
  )
}

export function SitusFooter({ produk }: { produk: Produk[] }) {
  return (
    <footer>
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-6 py-14 sm:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <div className="flex items-center gap-2.5">
            <img src="/favicon.svg" alt="" className="size-6" />
            <span className="text-base font-semibold tracking-tight">Orisini</span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-muted-foreground">
            A social media posting scheduler that works from your own computer. One account and
            one plan for every platform.
          </p>
        </div>

        <nav className="lg:col-span-3">
          <h2 className="text-xs text-muted-foreground">Products</h2>
          <ul className="mt-4 space-y-3 text-sm">
            {produk.map((p) => (
              <li key={p.code}>
                {PRODUK_SIAP.has(p.code) ? (
                  <a
                    href={p.origin}
                    className="rounded-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                  >
                    {p.name}
                  </a>
                ) : (
                  <span className="text-muted-foreground">
                    {p.name} <span className="text-xs">· coming soon</span>
                  </span>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <nav className="lg:col-span-3">
          <h2 className="text-xs text-muted-foreground">Account</h2>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <Tautan to="/register">Create account</Tautan>
            </li>
            <li>
              <Tautan to="/login">Sign in</Tautan>
            </li>
            <li>
              <Tautan to="/download">Download agent</Tautan>
            </li>
            <li>
              <a
                href="#pricing"
                className="rounded-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                Pricing
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center gap-x-6 gap-y-2 px-6 pb-10 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Orisini</span>
        <Tautan to="/privacy">Privacy Policy</Tautan>
        <Tautan to="/terms">Terms of Service</Tautan>
        <span>Interface in English.</span>
      </div>
    </footer>
  )
}
